import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';
import logo from '../images/clogo.png'; // Corrected path
import logoBelow from '../images/clogo1.png'; // Corrected path

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <nav className="navbar">
      <div className="nav-logo-container">
        <img src={logo} alt="Logo 1" className="nav-logo-img" />
        <img src={logoBelow} alt="Logo 2" className="nav-logo-img-below" />
      </div>

      <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/products">Products</Link></li>
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/contact">Contact Us</Link></li>
      </ul>

      <div className="nav-dropdown">
        <button className="dropdown-btn" onClick={toggleDropdown}>
          Menu ▼
        </button>
        
        {dropdownOpen && (
          <ul className="dropdown-menu">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        )}
      </div>
    </nav>
  );
};

export default Navbar;